import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import { QueryResult } from "@/api/utils/types"
import { WarrantsCommunicationParser } from "@/models/admin/warrantsCommunication/warrantsCommunication.parser"
import { IWarrantsCommunication } from "@/models/admin/warrantsCommunication/warrantsCommunication.types"
import {
  Financials_Warrants_Communications_Bool_Exp,
  Financials_Warrants_Communications_Order_By,
  GetWarrantsCommunicationsQuery,
} from "@/api/hasura/generated/graphql"

export interface WarrantsCommunicationListResult {
  communications: IWarrantsCommunication[]
  totalCount: number
}

class WarrantsCommunicationServiceClass {
  getCommunications(
    groupId: number,
    page: number,
    pageSize: number,
    orderBy: Financials_Warrants_Communications_Order_By,
  ): QueryResult<WarrantsCommunicationListResult> {
    const where: Financials_Warrants_Communications_Bool_Exp = {
      group_id: { _eq: groupId },
    }

    return useQuery({
      ...HasuraQueries.warrants.communications(
        (page - 1) * pageSize,
        pageSize,
        where,
        orderBy,
      ),
      useRawResponse: true,
      placeholderData: { communications: [], totalCount: 0 },
      parserFn: (
        data: GetWarrantsCommunicationsQuery,
      ): WarrantsCommunicationListResult => ({
        communications: data.financials_warrants_communications.map(
          WarrantsCommunicationParser.toDomain,
        ),
        totalCount:
          data.financials_warrants_communications_aggregate.aggregate?.count ??
          0,
      }),
    })
  }
}

export const WarrantsCommunicationService =
  new WarrantsCommunicationServiceClass()
